function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { flog } from '@zambezi/caballo-vivo';
import { of, from, concat, throwError, race, combineLatest } from 'rxjs';
import { map, switchMap, take, mapTo, flatMap } from 'rxjs/operators';
import { stringify } from 'query-string';
import { authToken$ } from './url-params';
import { createModal$, clearModal$ } from '@apiEnabler/api-enabler-common/lib/dialogs';
import { confirmLogOut$, cancelLogOut$, startLogOut$ } from './intents';
import axios from 'axios';
import { clientId$ } from './client-id';
import { pick } from 'ramda';
var uiConfigFromIndexTemplate$ = of(window.ui);
export var authorizationConfiguration$ = uiConfigFromIndexTemplate$.pipe(map(pick(['authorizationEndpoint', 'revocationEndpoint'])));
export var redirectIfUnauthenticated = function redirectIfUnauthenticated(error, store$) {
  if (error.type !== 'missing-access-token') throw error;
  return combineLatest(authorizationConfiguration$, clientId$).pipe(switchMap(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      authorizationEndpoint = _ref2[0].authorizationEndpoint,
      clientId = _ref2[1];
    return store$.pipe(take(1), map(function (state) {
      return state.set('redirectTo', "".concat(authorizationEndpoint, "?").concat(stringify({
        client_id: clientId,
        redirect_uri: window.location.href,
        response_type: 'token'
      })));
    }), flog('Redirecting to log-in'));
  }));
};
export var createLogout$ = function createLogout$(token) {
  return combineLatest(authorizationConfiguration$, clientId$).pipe(switchMap(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      revocationEndpoint = _ref4[0].revocationEndpoint,
      clientId = _ref4[1];
    return from(axios.post(revocationEndpoint, stringify({
      client_id: clientId,
      token: token,
      token_type_hint: 'access_token'
    }))).pipe(flog('Log out response'), mapTo(function (state) {
      return state.delete('customer');
    }));
  }));
};
export var doLogout$ = concat(authToken$.pipe(flatMap(createLogout$)), clearModal$, throwError(Object.assign(new Error('Logged Out'), {
  type: 'logged-out'
})));
export var logOut$ = startLogOut$.pipe(flatMap(function (access) {
  return concat(createModal$('logout.confirm', access), race(concat(confirmLogOut$, doLogout$), concat(cancelLogOut$, clearModal$)));
}));